export const hasEntitlement = (permissions, entitlement) =>
  Boolean(entitlement) &&
  Array.isArray(permissions?.entitlements) &&
  permissions.entitlements.includes(entitlement);
